const passkey_sign_in = {
    setup_page: {
        title: 'Упростите вход',
        subtitle: 'Создайте ключ-пароль',
        description: 'Зарегистрируйте ключ-пароль с помощью биометрии устройства, ключей безопасности вроде YubiKey или других доступных способов.',
    },
    trigger_conditional_ui_failed: 'Не удалось запустить автозаполнение passkey.',
};
export default Object.freeze(passkey_sign_in);
